import React, { useState, useEffect, useCallback } from 'react';
import { pagesAPI, toursAPI } from '../../services/api';
import Header2 from './Header2';
import Hero2 from './Hero2';
import About2 from './About2';
import Tours2 from './Tours2';
import Contact2 from './Contact2';
import Footer2 from './Footer2';
import '../../pages/Home.css';

const Home2 = () => {
  const [language, setLanguage] = useState('de');
  const [content, setContent] = useState(null);
  const [tours, setTours] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const loadContent = useCallback(async () => {
    setLoading(true);
    setError(null);

    try {
      const [pageData, toursData] = await Promise.all([
        pagesAPI.getPage(language),
        toursAPI.getTours(language)
      ]);

      setContent(pageData.data);
      setTours(toursData.data);
    } catch (err) {
      console.error('Failed to load content:', err);
      setError('Failed to load content. Please try again later.');
    } finally {
      setLoading(false);
    }
  }, [language]);

  const refreshContent = useCallback(async () => {
    try {
      const [pageData, toursData] = await Promise.all([
        pagesAPI.getPage(language),
        toursAPI.getTours(language)
      ]);

      setContent(pageData.data);
      setTours(toursData.data);
      setError(null);
    } catch (err) {
      console.error('Background content refresh failed:', err);
    }
  }, [language]);

  useEffect(() => {
    loadContent();
  }, [loadContent]);

  useEffect(() => {
    if (!content) return;

    if (content.title) {
      document.title = content.title;
    }

    const ensureMeta = (name, value) => {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement('meta');
        tag.setAttribute('name', name);
        document.head.appendChild(tag);
      }
      tag.setAttribute('content', value || '');
    };

    ensureMeta('description', content.meta_description);
    ensureMeta('keywords', content.meta_keywords);

    document.querySelectorAll('meta[data-seo-custom="true"]').forEach((el) => el.remove());

    if (content.meta_tags) {
      const parser = new DOMParser();
      const doc = parser.parseFromString(`<head>${content.meta_tags}</head>`, 'text/html');
      doc.head.querySelectorAll('meta').forEach((meta) => {
        const clone = meta.cloneNode(true);
        clone.setAttribute('data-seo-custom', 'true');
        document.head.appendChild(clone);
      });
    }
  }, [content]);

  useEffect(() => {
    const interval = setInterval(() => {
      if (!document.hidden) {
        refreshContent();
      }
    }, 60000);

    return () => clearInterval(interval);
  }, [refreshContent]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="spinner"></div>
        <p>Loading...</p>
      </div>
    );
  }

  if (error || !content) {
    return (
      <div className="error-container">
        <h2>Oops!</h2>
        <p>{error || 'Content not found'}</p>
        <button onClick={loadContent} className="retry-button">
          Retry
        </button>
      </div>
    );
  }

  return (
    <div className="home2-page">
      <Header2 
        language={language} 
        onLanguageChange={setLanguage} 
        content={content}
        contactMobile={content.contact_mobile}
        contactEmail={content.contact_email}
      />
      <Hero2 content={content} />
      <About2 top={content.partner_text_top || content.partner_text} bottom={content.partner_text_bottom} />
      <Tours2 tours={tours} heading={content.offers_heading} language={language} />
      <Contact2 content={content} />
      <Footer2 language={language} />
    </div>
  );
};

export default Home2;
